import axios from 'axios';
import endpointNames from "../configs/serverUrls";

//url variable
const baseUrl = endpointNames.report;

//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

const accidentClaims = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.accidentClaims, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const comprehensiveClaims = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.comprehensiveClaims, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const funeralClaims = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.funeralClaims, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const investmentsClaims = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.investmentClaims, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const inothoClaims = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.inothoClaims, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const paByAggregator = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.paByAggregator, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const paByIndustry = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.paByIndustry, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const paByPolicyType = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.paByPolicyType, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const paidClaims = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.paidClaims, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const claimsTurnAround = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.claimsTurnAround, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const deathClaims = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.deathClaims, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const deathClaimsPerProduct = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.deathClaimsByProduct, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const paymentHistory = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.paymentHistory, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const commissionsData = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.commissionsData, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const revenueData = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.revenueData, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const leadsData = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.leads, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const savingsDueToMature = async () => {
    let response;

    await axios.get(baseUrl.savingsDueToMature, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const inothoDueToMature = async () => {
    let response;

    await axios.get(baseUrl.inothoDueToMature, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const listOfAccountsData = async (request) => {
    let response;

    console.log(request);

    await axios.post(baseUrl.listOfAccounts, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const riskProfilesData = async (index) => {
    let response;


    await axios.get(baseUrl.riskProfiles + '?page=' + index, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}

const deletedPolicies = async () => {
    let response;


    await axios.get(baseUrl.deleted, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.error(err);
            response = err;
        })

    return response;
}


export default {
    accidentClaims,
    comprehensiveClaims,
    funeralClaims,
    investmentsClaims,
    paidClaims,
    claimsTurnAround,
    inothoClaims,
    paByAggregator,
    paByIndustry,
    paByPolicyType,
    paymentHistory,
    commissionsData,
    revenueData,
    leadsData,
    savingsDueToMature,
    listOfAccountsData,
    riskProfilesData,
    deathClaimsPerProduct,
    deathClaims,
    deletedPolicies,
    inothoDueToMature
}
